<template>
  <div>
    <transition name="search">
      <div v-if="opened" class="search-overlay"></div>
    </transition>
    <transition name="search">
      <div v-if="opened" class="search-container">
        <div class="search-aside">
          <global-search-filter
            v-model="type"
            :results="results"
          ></global-search-filter>
        </div>
        <div class="search-main">
          <global-search-input
            ref="input"
            :centered="results.length === 0"
            :no-results="noResults"
            :processing="processing"
            @change="string => change(string)"
          ></global-search-input>
          <transition name="search-mobile-filter">
            <global-search-mobile-filter
              v-if="results.length > 0"
              v-model="type"
              :results="results"
            ></global-search-mobile-filter>
          </transition>
          <global-search-results
            v-if="results.length"
            :results="filteredResults"
            :type="type"
          ></global-search-results>
        </div>
        <div class="search-close" @click="close">
          <i class="fal fa-arrow-left"></i>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios'
import GlobalSearchInput from '@/components/search/GlobalSearchInput'
import GlobalSearchResults from '@/components/search/GlobalSearchResults'
import GlobalSearchFilter from '@/components/search/GlobalSearchFilter'
import GlobalSearchMobileFilter from '@/components/search/GlobalSearchMobileFilter'

export default {
  components: {
    GlobalSearchInput,
    GlobalSearchResults,
    GlobalSearchFilter,
    GlobalSearchMobileFilter
  },
  data() {
    return {
      opened: false,
      results: [],
      type: null,
      noResults: false,
      processing: false,
      controller: null
    }
  },
  computed: {
    filteredResults() {
      if (this.type) {
        return this.results.filter(result => result.type === this.type.key)
      } else {
        return this.results
      }
    }
  },
  mounted() {
    const triggers = document.querySelectorAll('[data-search-trigger')

    triggers.forEach(trigger => {
      trigger.addEventListener('click', e => {
        e.preventDefault()
        this.opened = true
        setTimeout(() => {
          this.$refs.input.focus()
        }, 200)
      })
    })
  },
  methods: {
    change(string) {
      this.noResults = false

      if (string.length) {
        this.getResults(string)
      } else {
        this.results = []
      }
    },
    getResults(string) {
      this.processing = true
      if (this.controller) {
        this.controller.abort()
      }
      this.controller = new AbortController()
      axios
        .get(`/search/${string}?_format=json`, {
          signal: this.controller.signal
        })
        .then(response => {
          this.results = response.data
          this.processing = false
          this.controller = null
          if (this.results.length === 0) {
            this.noResults = true
          }
        })
    },
    close() {
      this.opened = false
      this.results = []
      this.type = null
    }
  },
  watch: {
    opened(value) {
      if (value) {
        document.querySelector('body').classList.add('is-scroll-disabled')
      } else {
        document.querySelector('body').classList.remove('is-scroll-disabled')
      }
    }
  }
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}
.search-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: linear-gradient(
    160deg,
    rgba(0, 231, 0, 0.75) 0%,
    rgba(165, 52, 255, 0.75) 60%
  );
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  opacity: 0;
  transition: opacity 0.2s;

  &.is-visible {
    opacity: 1;
  }
}

.search-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
}

.search-aside {
  width: 350px;
  flex-shrink: 0;
  border-right: solid 1px rgba(#ffffff, 0.2);
}

.search-main {
  flex-grow: 1;
  padding: 165px 100px 0 67px;
  overflow: scroll;
}

.search-input {
  position: fixed;
  top: 33px;
  right: 100px;
  left: 417px;

  transition: all 0.3s;

  input {
    width: 100%;
    height: 71px;
    padding-left: 30px;
    opacity: 0.8;

    background: #0f0f0f;
    border: none;
    border-radius: 10px;
    outline: none;

    color: #ffffff;
    font-family: 'Trade Gothic', sans-serif;
    font-size: 28px;
    font-weight: 700;
    text-transform: uppercase;
  }

  &.is-centered {
    transform: translateY(50vh);

    input {
      height: 140px;
      background: none;
      border-bottom: solid 1px rgba(#ffffff, 0.2);
      border-radius: 0;
      font-size: 130px;
      color: rgba(209, 177, 236, 0.8);
      letter-spacing: -0.7px;
    }

    .search-input-icon {
      width: 140px;
    }
  }
}

.search-input-icon {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 71px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: red;

  i {
    font-size: 20px;
  }
}
.search-input-clear {
  @extend .search-input-icon;

  background: blue;
  cursor: pointer;
}

.search-input-noresults {
  position: absolute;
  top: 100%;
  margin-top: 20px;
  font-size: 20px;
  font-weight: 300;
  color: #f0f0f0;
  letter-spacing: 0;
}

.search-result {
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: solid 1px rgba(#ffffff, 0.2);
}

.search-result-title {
  margin-bottom: 6px;
  color: #ffffff;
  font-family: 'Trade Gothic', sans-serif;
  font-size: 40px;
  font-weight: 700;
  letter-spacing: -0.7px;
  line-height: 1.1;
  text-transform: uppercase;
}

.search-result-url {
  opacity: 0.8;
  font-size: 16px;
  color: #ffffff;
}
</style>
